import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//AUTH UIS

import Login from './ui/Auth/Login';

//SIDEBAR GLOBAL
import MainLayout from './ui/MainLayout';


//UIS ADMIN

import HomeAdmin from './ui/Admin/Home';

import AdminPerfil from './ui/Admin/Perfil/PerfilUI';

import Clientes from './ui/Admin/Clientes/ClientesUI';

import AsignarAvalesUI from './ui/Admin/Asignar-Avales/AsignarAvalesUI';

import Asesores from './ui/Admin/Empleados/AsesoresUI';

import CalculadoraUI from './ui/Admin/Calculadora/CalculadoraUI';

import Estados from './ui/Admin/Estados/EstadosUI';

import GestionMorasAdmin from './ui/Admin/GestionMoras/GestionMorasUI';

import FiltroPagosUI from './ui/Admin/FiltrarPagos/FiltrarPagosUI';

import FiltrarPrestamos from './ui/Admin/FiltrarPrestamos/FiltrarPrestamosUI';

import Cronograma from './ui/Admin/Cronograma/CronogramaUI';

import Productos from './ui/Admin/Productos/ProductosUI';

import GestionCarteraUI from './ui/Admin/Gestion-Cartera/GestionCarteraUI';

import Dashboard from './ui/Admin/Dashboard/DashboardUI';

import Renta from './ui/Admin/Renta/RentaUI';

import FinanzasUI from './ui/Admin/Finanzas/FinanzasUI';

import PrestamosActivosUI from './ui/Admin/Prestamos-Activos/PrestamosActivosUI';

import ClientesSinPrestamoUI from './ui/Admin/Clientes-Sin-Prestamo/ClientesSinPrestamoUI';

import EgresosUI from './ui/Admin/Egresos/EgresosUI';

import IngresosUI from './ui/Admin/Ingresos/IngresosUI';

//UIS OPERACIONES
import CalculadoraOperacionesUI from './ui/Operaciones/Calculadora/CalculadoraUI';
import CronogramaOperacionesUI from './ui/Operaciones/Cronograma/CronogramaUI';
import ClientesOperacionesUI from './ui/Operaciones/Clientes/ClientesUI';

//UIS CONTABILIDAD
import EgresosContabilidadUI from './ui/Contabilidad/Egresos/EgresosUI';
import IngresosContabilidadUI from './ui/Contabilidad/Ingresos/IngresosUI';
import FinanzasContabilidadUI from './ui/Contabilidad/Finanzas/FinanzasUI';

//UIS CLIENTE

import EstadosCliente from './ui/Cliente/Estados/EstadosUI';
import ResumenCliente from './ui/Cliente/Resumen/ResumenUI';
import CronogramaCliente from './ui/Cliente/Cronograma/CronogramaUI';
import MisPagos from './ui/Cliente/MisPagos/MisPagosUI';

//UIS ASESOR
import HomeAsesor from './ui/Asesor/Clientes/ClientesUI';
import CuotasPendientesAsesor from './ui/Asesor/CuotasPendientes/CuotasPendientesUI';
import GestionMorasAsesor from './ui/Asesor/GestionMoras/GestionMorasUI';
import MisDesembolsosAsesor from './ui/Asesor/MisDesembolsos/MisDesembolsosUI';

//UIS AUDITOR
import HomeAuditor from './ui/Auditor/FiltrarPagos/FiltrarPagosUI';
import FiltrarPrestamosAuditor from './ui/Auditor/FiltrarPrestamos/FiltrarPrestamosUI';
import CronogramaAuditor from './ui/Auditor/Cronograma/CronogramaUI';

//UI CAJERO
import EstadosCajero from './ui/Cajero/Estados/EstadosUI';
import CajaCajero from './ui/Cajero/Caja/CajaUI';

//Portectoresde rutas
import ProtectedRouteHome from './utilities/ProtectedRouteHome';

import ProtectedRouteAdmin from './utilities/ProtectedRouteAdmin';

import ProtectedRouteCliente from './utilities/ProtectedRouteCliente';

import ProtectedRouteAsesor from './utilities/ProtectedRouteAsesor';

import ProtectedRouteAuditor from './utilities/ProtectedRouteAuditor';

import ProtectedRouteCajero from './utilities/ProtectedRouteCajero';

import ProtectedRouteOperaciones from './utilities/ProtectedRouteOperaciones';

import ProtectedRouteContabilidad from './utilities/ProtectedRouteContabilidad';

import ProtectedRouteToken from './utilities/ProtectedRouteToken';

//ERROR PAGES

import ErrorPage from './components/ErrorPage404';

import Error401Page from './components/ErrorPage401';


function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta por defecto */}
        <Route path="/" element={<ProtectedRouteHome element={<Login />} />} />

        {/* Rutas de Error */}
        <Route path="/*" element={<ErrorPage />} />

        <Route path="/401" element={<Error401Page />} />

        <Route element={<ProtectedRouteToken element={<MainLayout />} />}>

          {/* Rutas para Admin */}

          <Route path="/admin/home" element={<ProtectedRouteAdmin element={<HomeAdmin />} />} />

          <Route path="/admin/perfil" element={<ProtectedRouteAdmin element={<AdminPerfil />} />} />

          <Route path="/admin/calculadora" element={<ProtectedRouteAdmin element={<CalculadoraUI />} />} />

          <Route path="/admin/clientes" element={<ProtectedRouteAdmin element={<Clientes />} />} />

          <Route path="/admin/asignar-avales" element={<ProtectedRouteAdmin element={<AsignarAvalesUI />} />} />

          <Route path="/admin/asesores" element={<ProtectedRouteAdmin element={<Asesores />} />} />

          <Route path="/admin/estados" element={<ProtectedRouteAdmin element={<Estados />} />} />

          <Route path="/admin/gestion-moras" element={<ProtectedRouteAdmin element={<GestionMorasAdmin />} />} />

          <Route path="/admin/pagos/filtros" element={<ProtectedRouteAdmin element={<FiltroPagosUI />} />} />

          <Route path="/admin/gestion-cartera" element={<ProtectedRouteAdmin element={<GestionCarteraUI />} />} />

          <Route path="/admin/historial-prestamos" element={<ProtectedRouteAdmin element={<FiltrarPrestamos />} />} />

          <Route path="/admin/cronograma" element={<ProtectedRouteAdmin element={<Cronograma />} />} />

          <Route path="/admin/productos" element={<ProtectedRouteAdmin element={<Productos />} />} />
          
          <Route path = "/admin/dashboard" element={<ProtectedRouteAdmin element={<Dashboard />} />} />

          <Route path = "/admin/dashboard/renta" element={<ProtectedRouteAdmin element={<Renta />} />} />

          <Route path = "/admin/finanzas" element={<ProtectedRouteAdmin element={<FinanzasUI />} />} />

          <Route path="/admin/egresos" element={<ProtectedRouteAdmin element={<EgresosUI />} />} />
          
          <Route path="/admin/ingresos" element={<ProtectedRouteAdmin element={<IngresosUI />} />} />

          <Route path="/admin/prestamos-activos" element={<ProtectedRouteAdmin element={<PrestamosActivosUI />} />} />

          <Route path="/admin/clientes-sin-prestamo" element={<ProtectedRouteAdmin element={<ClientesSinPrestamoUI />} />} />

          {/* Rutas para Operaciones */}

          <Route path="/operaciones/calculadora" element={<ProtectedRouteOperaciones element={<CalculadoraOperacionesUI />} />} />

          <Route path="/operaciones/cronograma" element={<ProtectedRouteOperaciones element={<CronogramaOperacionesUI />} />} />

          <Route path="/operaciones/clientes" element={<ProtectedRouteOperaciones element={<ClientesOperacionesUI />} />} />

          {/* Rutas para Contabilidad */}

          <Route path="/contabilidad/egresos" element={<ProtectedRouteContabilidad element={<EgresosContabilidadUI />} />} />

          <Route path="/contabilidad/ingresos" element={<ProtectedRouteContabilidad element={<IngresosContabilidadUI />} />} />

          <Route path="/contabilidad/finanzas" element={<ProtectedRouteContabilidad element={<FinanzasContabilidadUI />} />} />


          {/* Rutas para Cliente */}

          <Route path="/cliente/estados" element={<ProtectedRouteCliente element={<EstadosCliente />} />} />

          <Route path="/cliente/resumen" element={<ProtectedRouteCliente element={<ResumenCliente />} />} />

          <Route path="/cliente/cronograma" element={<ProtectedRouteCliente element={<CronogramaCliente />} />} />

          <Route path="/cliente/mispagos" element={<ProtectedRouteCliente element={<MisPagos />} />} />

          {/* Rutas par Asesor */}

          <Route path="/asesor/home" element={<ProtectedRouteAsesor element={<HomeAsesor />} />} />

          <Route path="/asesor/cuotas-pendientes" element={<ProtectedRouteAsesor element={<CuotasPendientesAsesor />} />} />

          <Route path="/asesor/gestion-moras" element={<ProtectedRouteAsesor element={<GestionMorasAsesor />} />} />

          <Route path="/asesor/mis-desembolsos" element={<ProtectedRouteAsesor element={<MisDesembolsosAsesor />} />} />

          {/* Rutas par Auditor */}

          <Route path="/auditor/home" element={<ProtectedRouteAuditor element={<HomeAuditor />} />} />

          <Route path="/auditor/historial-prestamos" element={<ProtectedRouteAuditor element={<FiltrarPrestamosAuditor />} />} />

          <Route path="/auditor/cronograma" element={<ProtectedRouteAuditor element={<CronogramaAuditor />} />} />

          {/* Rutas para cajero */}

          <Route path="/cajero/home" element={<ProtectedRouteCajero element={<EstadosCajero />} />} />
          <Route path="/cajero/estados" element={<ProtectedRouteCajero element={<EstadosCajero />} />} />
          <Route path="/cajero/caja" element={<ProtectedRouteCajero element={<CajaCajero />} />} />

        </Route>
      </Routes>

      {/* ToastContainer global */}
      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
}

export default App;